import type {
  WarehouseOrderEventAutomation,
  WarehouseOrderEventAutomationStatus,
} from 'contracts/WarehouseOrderEventAutomations';
import { api } from 'services';

const getWarehouseOrderEventAutomations = async (): Promise<
  WarehouseOrderEventAutomation[]
> => {
  const { data } = await api.get<WarehouseOrderEventAutomation[]>(
    'warehouse-order-event-automations'
  );
  return data;
};

const getWarehouseOrderEventAutomation = async (
  warehouseId: number
): Promise<WarehouseOrderEventAutomationStatus> => {
  const { data } = await api.get<WarehouseOrderEventAutomationStatus>(
    `warehouse-order-event-automations/${warehouseId}`
  );
  return data;
};

const replaceWarehouseOrderEventAutomations = async (
  warehouseIds: number[]
): Promise<WarehouseOrderEventAutomation[]> => {
  const { data } = await api.put<WarehouseOrderEventAutomation[]>(
    'warehouse-order-event-automations',
    { warehouseIds }
  );
  return data;
};

export function useWarehouseOrderEventAutomations() {
  return {
    getWarehouseOrderEventAutomations,
    getWarehouseOrderEventAutomation,
    replaceWarehouseOrderEventAutomations,
  };
}
